import React from "react";
import { Button } from "@/components/ui/button";
import {
  UserCircle,
  Clock,
  Heart,
  LogOut,
  Bookmark,
  BarChart3,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/components/ui/use-toast";
import { useAudioPlayer } from "@/contexts/AudioPlayerContext";

const Profile = () => {
  const navigate = useNavigate();
  const { signOut, isAdmin } = useAuth();
  const { toast } = useToast();
  const {
    likedEpisodes,
    setQueueEpisodes,
    setAllEpisodes,
    setDisplayedEpisodes,
  } = useAudioPlayer();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/login");
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to sign out",
        variant: "destructive",
      });
    }
  };

  const handleNavigateToLikes = () => {
    // Preprocess queue with liked episodes
    if (likedEpisodes.length > 0) {
      console.log("Initializing liked episodes queue:", likedEpisodes.length);
      setAllEpisodes(likedEpisodes);
      setQueueEpisodes(likedEpisodes);
      setDisplayedEpisodes(likedEpisodes);
    }
    navigate("/profile/liked");
  };

  return (
    <div className="w-full bg-white/5 backdrop-blur-md rounded-xl border border-white/20 shadow-xl overflow-hidden">
      <div className="p-6 flex flex-col gap-2">
        <h2 className="text-2xl font-semibold text-center mb-4 text-gray-800">
          Profile
        </h2>

        <Button
          variant="outline"
          className="w-full flex items-center gap-2 justify-start h-14 bg-white/30 hover:bg-white/40 border-white/30 text-gray-800"
          onClick={() => navigate("/profile/edit")}
        >
          <UserCircle className="h-5 w-5" />
          Edit Profile
        </Button>

        <Button
          variant="outline"
          className="w-full flex items-center gap-2 justify-start h-14 bg-white/30 hover:bg-white/40 border-white/30 text-gray-800"
          onClick={handleNavigateToLikes}
        >
          <Heart className="h-5 w-5" />
          Likes
        </Button>

        <Button
          variant="outline"
          className="w-full flex items-center gap-2 justify-start h-14 bg-white/30 hover:bg-white/40 border-white/30 text-gray-800"
          onClick={() => navigate("/profile/bookmarked")}
        >
          <Bookmark className="h-5 w-5" />
          Bookmarks
        </Button>

        <Button
          variant="outline"
          className="w-full flex items-center gap-2 justify-start h-14 bg-white/30 hover:bg-white/40 border-white/30 text-gray-800"
          onClick={() => navigate("/profile/history")}
        >
          <Clock className="h-5 w-5" />
          History
        </Button>

        {isAdmin && (
          <Button
            variant="outline"
            className="w-full flex items-center gap-2 justify-start h-14 bg-gradient-to-r from-[#735fe2] to-[#627ae2] hover:opacity-90 text-white border-transparent"
            onClick={() => navigate("/analytics")}
          >
            <BarChart3 className="h-5 w-5" />
            Analytics Dashboard
          </Button>
        )}

        <div className="border-t border-white/10 pt-4 mt-2">
          <Button
            variant="destructive"
            className="w-full flex items-center gap-2 justify-center h-14 bg-red-500 hover:bg-red-600"
            onClick={handleSignOut}
          >
            <LogOut className="h-5 w-5" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
